module.exports = __webpack_public_path__ + "img/1x.d6464c1.jpg";